import { RxCross1 } from 'react-icons/rx';
import { BsCheckLg } from 'react-icons/bs';
import css from './BottomPart.module.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { BsFillMicFill } from 'react-icons/bs';
import { BsCameraFill } from 'react-icons/bs';
import { BiSolidMessageDetail } from 'react-icons/bi';
import { FaArrowLeft } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa';
import { TiHome } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import {
  clearDiag,
  clearRepair,
  deleteCarInfo,
  deleteNewCar,
} from '../../redux/cars/slice';

export default function BottomPart({
  back,
  next,
  button,
  categ,
  btnToggle,
  buttonSpares,
  chosenPoints,
  savedPartBottom,
  handleCreateDiag,
  savedPartScreen,
  setOpenCamera,
  setRecordAudio,
  repair,
  audioURL,
  photosFromWorksPart,
  setOpenComment,
  comment,
  setOpenPhotoComp,
  diag,
  chosenParts,
  setSavedSparesPartOpen,
  createVoiceDiag,
  // voiceDiag,
  audioURLVoiceDiag,
  voiceDiagParts,
  savedSparesPartOpen,
  setOpenPhotos,
  diagnosticType,
}) {
  const isDisabled =
    diagnosticType === 'voice'
      ? savedSparesPartOpen
        ? voiceDiagParts?.length === 0
        : !audioURLVoiceDiag
      : chosenParts?.length === 0;
  // console.log('voiceDiag', voiceDiag);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onHomeBtnClick = () => {
    dispatch(deleteCarInfo());
    dispatch(deleteNewCar());
    dispatch(clearRepair());
    dispatch(clearDiag());
    navigate(`/main`);
    console.log('cleared');
  };

  return (
    <div
      className={`${css.wrapper} ${savedPartScreen ? css.wrapperSaved : ''}`}
    >
      {button || buttonSpares ? (
        <button
          type="button"
          onClick={back}
          className={`${css.cancel} ${savedPartScreen ? css.savedScreen : ''}`}
        >
          <FaArrowLeft className={css.icon} />
        </button>
      ) : (
        <NavLink to={back} className={css.cancel}>
          <FaArrowLeft className={css.icon} />
        </NavLink>
      )}

      {categ || diagnosticType === 'voice' ? (
        <>
          <NavLink to="/main" className={css.home}>
            <TiHome className={css.icon} />
          </NavLink>
          <div
            className={`${css.greyCircle} ${audioURL && css.greenCircle}`}
            onClick={() => setRecordAudio(true)}
          >
            <BsFillMicFill className={css.icon} />
          </div>
          <div
            className={`${css.greyCircle} ${
              !repair && photosFromWorksPart?.length > 0 && css.greenCircle
            }`}
            onClick={() => {
              if (diag && photosFromWorksPart.length > 0) {
                setOpenCamera(false);
              } else {
                setOpenCamera(true);
              }
              setOpenPhotoComp(true);
              // setOpenPhotos(true);
            }}
          >
            <BsCameraFill className={css.icon} />
          </div>
          <div
            className={`${css.greyCircle} ${comment && css.greenCircle}`}
            onClick={() => setOpenComment(true)}
          >
            <BiSolidMessageDetail className={css.icon} />
          </div>
        </>
      ) : (
        <button className={css.home} onClick={onHomeBtnClick}>
          <TiHome className={css.icon} />
        </button>
      )}
      {/* 
      categ ? (
        <div style={{ width: '41px' }}></div>
      ) : */}
      {/* {btnToggle || buttonSpares ? ( */}
      <button
        type="button"
        onClick={() => {
          if (savedPartBottom && !repair) {
            handleCreateDiag();
          } else if (diagnosticType === 'voice') {
            createVoiceDiag();
          } else {
            next();
          }
        }}
        className={`${css.confirm} ${isDisabled && css.confirmDisabled} ${
          savedPartScreen ? css.savedScreen : ''
        }`}
        disabled={isDisabled}
      >
        {savedPartBottom || repair ? (
          <BsCheckLg className={css.icon} />
        ) : (
          <FaArrowRight className={css.icon} />
        )}
      </button>
      {/* ) : (
        <NavLink to={next} className={css.confirm}>
          <FaArrowRight className={css.icon} />
        </NavLink>
      )} */}

      <button
        type="button"
        onClick={() => {
          if (
            (savedPartBottom && !repair) ||
            (diagnosticType === 'tree' && chosenParts?.length > 0)
          ) {
            handleCreateDiag();
          } else if (diagnosticType === 'voice') {
            createVoiceDiag();
          } else {
            next();
          }
        }}
        className={`${css.confirmForTablet} ${isDisabled && css.confirmDisabled} ${
          savedPartScreen ? css.savedScreen : ''
        }`}
        disabled={isDisabled}
      >
        {diagnosticType === 'voice' && !savedPartBottom ? (
          <FaArrowRight className={css.icon} />
        ) : (
          <BsCheckLg className={css.icon} />
        )}
      </button>
      {}
    </div>
  );
}
